import React from "react";
import { useFormikContext } from "formik";

export const FormikBridge = ({ children }) => {
  const formik = useFormikContext();
  
  window.invenioFormik = formik;

  return <>{children}</>;
};
